<pba-template-auth *ngIf="partner$ | async as partner">
  <form [formGroup]="createNewPassForm" (submit)="setNewPassword()" class="w-full" novalidate>
    <div class="frame-content flex flex-col justify-center items-center wh-full gap-4">
      <ng-container *ngIf="ssoLoginButtons$ | async as ssoLoginButtons">
        <ng-container *ngIf="ssoLoginButtons.length && activationToken; else normalDomain">
          <div class="title title-container" [class.flex-col]="!enableSetPassword || !showNavigateBefore">
            <mat-icon *ngIf="enableSetPassword && showNavigateBefore" (click)="back()" color="primary" class="btn-back"
              >navigate_before</mat-icon
            >
            <div>{{ title }}</div>
          </div>

          <ng-container *ngIf="!enableSetPassword; else setPassword">
            <b3n-sso-login-button
              *ngFor="let sso of ssoLoginButtons"
              [activationToken]="activationToken"
              [authorizeProvider]="sso.authorizeProvider"
              [url]="sso.url"
              [text]="sso.activateText || ''"
              [email]="email"
              (inputPassword)="next()"
              class="w-full"
            ></b3n-sso-login-button>
          </ng-container>

          <ng-template #setPassword>
            <mat-form-field class="new-password-input w-full">
              <mat-label>Your password</mat-label>
              <input
                matInput
                [type]="showPassword ? 'text' : 'password'"
                placeholder="Your password"
                formControlName="password"
                (input)="showErrorSummary = false"
                required
                [minlength]="6"
              />
              <button type="button" mat-icon-button matSuffix (click)="showPassword = !showPassword">
                <mat-icon>{{ showPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
              </button>
            </mat-form-field>
            <div class="noti-summary error" *ngIf="showErrorSummary">{{ error }}</div>
            <ng-container *ngTemplateOutlet="passwordPolicySection"></ng-container>

            <button
              mat-raised-button
              type="submit"
              color="primary"
              [loading]="indicator"
              [style.backgroundColor]="createNewPassForm.valid && !indicator ? partner.loginButtonBackground : ''"
              [disabled]="createNewPassForm.invalid || indicator"
              class="w-full"
            >
              Set password
            </button>
          </ng-template>
        </ng-container>

        <ng-template #normalDomain>
          <div class="title">Enter password</div>
          <mat-form-field class="new-password-input w-full">
            <mat-label>New password</mat-label>
            <input
              matInput
              [type]="showPassword ? 'text' : 'password'"
              placeholder="New password"
              formControlName="password"
              (input)="showErrorSummary = false"
              required
              [minlength]="6"
            />
            <button type="button" mat-icon-button matSuffix (click)="showPassword = !showPassword">
              <mat-icon>{{ showPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
          </mat-form-field>
          <div class="noti-summary error" *ngIf="showErrorSummary">{{ error }}</div>
          <ng-container *ngTemplateOutlet="passwordPolicySection"></ng-container>

          <button
            mat-raised-button
            type="submit"
            color="primary"
            [loading]="indicator"
            [style.backgroundColor]="createNewPassForm.valid && !indicator ? partner.loginButtonBackground : ''"
            [disabled]="createNewPassForm.invalid || indicator"
            class="w-full"
          >
            Create new password
          </button>
        </ng-template>
      </ng-container>
    </div>
  </form>
</pba-template-auth>

<ng-template #passwordPolicySection>
  <div *ngIf="loadedPasswordPolicy" class="password-complexity">
    <div>Password must comply with the following requirements:</div>
    <div
      [class.touched]="password.touched || password.dirty"
      [ngClass]="{
        error: password.hasError('minlength') || password.hasError('required'),
        success: !password.hasError('minlength') && !password.hasError('required')
      }"
    >
      - At least {{ passwordPolicy?.minimumLength || 6 }} characters
    </div>
    <div
      *ngIf="passwordPolicy?.maximumLength"
      [class.touched]="password.touched || password.dirty"
      [ngClass]="{
        error: password.hasError('maxlength'),
        success: !password.hasError('maxlength')
      }"
    >
      - At most {{ passwordPolicy.maximumLength }} characters
    </div>
    <div *ngFor="let policy of policies">
      <span
        *ngIf="passwordPolicy?.[policy.name] || !passwordPolicy"
        [class.touched]="password.touched || password.dirty"
        [ngClass]="{ error: password.hasError(policy.name), success: !password.hasError(policy.name) }"
        >{{ policy.displayText }}</span
      >
    </div>
  </div>
</ng-template>
